import { render } from "./LessonDogsTopic5.vue?vue&type=template&id=505b8aa0"
import script from "./LessonDogsTopic5.vue?vue&type=script&lang=js"
export * from "./LessonDogsTopic5.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__